import React, { useState, useEffect } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import CentrikaIcon from "../../assets/img/logo.png";
import OperatorLogo from "../../assets/img/bus.png";
import SafariLogo from "../../assets/img/logo.svg";
import PropTypes from 'prop-types';
import {
  Button,
  Drawer,
  ListItemText,
  IconButton,
  ListItemIcon,
  ListItem,
  Divider,
  List,
  Grid,
  Paper,
  Typography,
  Toolbar,
  AppBar,
  Container,
  Box,
  Hidden,
  Menu,
  MenuItem,
  Avatar,
  useMediaQuery,
  Badge,
  ButtonBase,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,Tabs,Tab,Chip, TextField, LinearProgress,
  ListItemSecondaryAction,
  CircularProgress,
  ButtonGroup,
  Popover,
  Switch
  
} from "@material-ui/core";

import {
  Menu as MenuIcon,
  Home,
  Equalizer,
  Settings,
  ExitToApp,
  ArrowDropDown,
  HelpRounded,
  Notifications,
  Group,
  SupervisedUserCircle,
  Store,
  Security,
  AllInclusive,
  Gavel,
  Schedule,
  Subway,
  AirportShuttle,
  CreditCard,
  Block,
  Mail,
  Place,
  DepartureBoard,
  Assignment,
  Category,
  Assessment,
  ExpandLess,
  ExpandMore,
  ArrowRight,
  Timeline,
  MoneyOff,
  LocalAtm,
  WbIncandescentOutlined,
  DevicesOther,TrendingUp,ImportExport,ArrowDropUp,ConfirmationNumber,
  AccountBalance,AccountBalanceWallet,SwapHoriz,
  PeopleAltOutlined,DevicesOtherOutlined,
  OutlinedFlagOutlined,SettingsOutlined,
  Visibility,SettingsCell,
  AccountCircleOutlined,
  ArrowForwardIos,
  ImportantDevices,
  Language,Done,
  AccountBalanceWalletOutlined,
  PaymentOutlined,CancelPresentationOutlined,
  PhoneAndroidOutlined,
  CheckCircleOutlined,
  CheckCircleOutline,
  Devices,
  HdrWeak,
  AlternateEmail,
  PhoneAndroid,
  VpnKey,
  Edit,
  HighlightOff,
  Event,
  Money,
  Public,InsertDriveFileOutlined,
  EventAvailable,
  EventBusy,
  AssessmentOutlined,
  Today,
  FindReplace,
  DateRange,
  CalendarToday,
  AccountCircle
} 
  from "@material-ui/icons";

import { makeStyles, useTheme ,withStyles} from "@material-ui/styles";
import { Speed } from "@material-ui/icons";

import { withLocalize, Translate } from "react-localize-redux";

import { Link,  Route, useHistory } from "react-router-dom";

import Chart from "react-apexcharts";

import { useSnackbar } from 'notistack';

import MUIDataTable from "mui-datatables";

import CardTopup from "../../assets/svg/wallet.svg";
import Asettings from "../../assets/svg/asettings.svg";

import cBalance from "../../assets/svg/balance.svg";

import oBalance from "../../assets/svg/openbalance.svg";

import reserved from "../../assets/svg/reserved.svg";

import FloatAllocation from "../../assets/svg/float_allocation.svg";

import {weeklyTopup,AnnualTopUp} from "./test_data";
import UserInfo from "./login_info";
import axios from 'axios';
import {AdminService,FinanceService} from "./../../utils/web_config_2";

import Format from "date-fns/format";


import DateFnsUtils from "@date-io/date-fns";

import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";

import {groupBy} from "./../../utils/web_config_2";

const useStyles = makeStyles((theme) => ({
    root: {},
    title: {
      flexGrow: 1,
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
    },
    
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    btn: {
      textTransform: "capitalize",
    },
    paper: {
      padding: 15,
    },
    icon: {
      height: 45,
      marginRight: 10,
      display: "block",
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
    },
    main: theme.mixins.toolbar
  }));

  const AntSwitch = withStyles((theme) => ({
    root: {
      width: 28,
      height: 16,
      padding: 0,
      display: 'flex',
    },
    switchBase: {
      padding: 2,
      color: theme.palette.grey[500],
      '&$checked': {
        transform: 'translateX(12px)',
        color: theme.palette.common.white,
        '& + $track': {
          opacity: 1,
          backgroundColor: theme.palette.primary.main,
          borderColor: theme.palette.primary.main,
        },
      },
    },
    thumb: {
      width: 12,
      height: 12,
      boxShadow: 'none',
    },
    track: {
      border: `1px solid ${theme.palette.grey[500]}`,
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: theme.palette.common.white,
    },
    checked: {},
  }))(Switch);
  
  function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-auto-tabpanel-${index}`}
        aria-labelledby={`scrollable-auto-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };
  
  function a11yProps(index) {
    return {
      id: `scrollable-auto-tab-${index}`,
      'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
  }


function HomeIndividual(props){
    const classes = useStyles();
  const Theme = useTheme();
  const history = useHistory();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClose = () => {
    setAnchorEl(null);
  };
  const matches = useMediaQuery(Theme.breakpoints.up("sm"));
  const menuOpen = Boolean(anchorEl);



  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [value, setValue] =useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [agentData,setAgentData]=useState({});
  const [agentProfile,setAgentProfile]=useState({});

useEffect(()=>{
  const data=new UserInfo().DATA;
  setAgentData(data);
  get_profile(data['token']);
  get_transactions(data['token']);
  weeklyReport(data['token']);
},[]);


const [balanceMethod,setBalanceMethod]=useState(false);

const [loadProfile,setLoadProfile]=useState(false);
const [balance,setBalance]=useState(0);
const [currency,setCurrency]=useState("");
const [openBalance,setOpenBalance]=useState(0);
const [reservedAmount,setReservedAmount]=useState(0);
const [outlets,setOutlets]=useState([]);
const [statusAccount,setStatusAccount]=useState("");
const [agentType,setAgentType]=useState(null);

const get_profile=(token)=>{
  setLoadProfile(true);
  axios.defaults.baseURL = new FinanceService().BASE_URL;
  const profileInstance = axios.create(new FinanceService().setHeaders(token));
  profileInstance.get(new FinanceService().GET_AGENT_PROFILE+new UserInfo().AGENT_CODE)
  .then(res=>{
    var obj=res.data.data;
    setBalance(obj.account.current_balance);
    setOpenBalance(obj.account.opening_balance);
    setCurrency(obj.account.currency_code);
    setReservedAmount(obj.account.reserved_amount);
    setStatusAccount(obj.account.status);
    setOutlets(obj.outlets);
    setAgentProfile(obj);
    setLoadProfile(false);
    setAgentType(obj.agent_type_name);
    console.log("res",obj);
  })
  .catch(err=>{
    console.log("err",err);
  });
}


//   transactions table 


const columns = [
    {
      name: "tx_type_name",
      label: "Transaction Type",
      options: {
       filter: true,
       sort: true,
      }
     },
    {
     name: "channel_type",
     label: "Channel",
     options: {
      filter: true,
      sort: true,
     }
    },
    {
     name: "credited_account",
     label: "Account",
     options: {
      filter: true,
      sort: false,
     }
    },
    {
      name: "external_reference_number",
      label: "External Reference",
      options: {
       filter: true,
       sort: false,
      }
     },
    {
      name: "amount",
      label: "Amount",
      options: {
       filter: true,
       sort: false,
       customBodyRender: (value, tableMeta, updateValue) => {
       return (<Typography>{formatMoney(value,0)}</Typography>);
     }
      }
     }, 
    // {
    //  name: "total_commission_amount",
    //  label: "Commissions",
    //  options: {
    //   filter: true,
    //   sort: false,
    //  }
    // }, 
    {
      name: "debited_account_balance",
      label: "Balance",
      options: {
       filter: true,
       sort: false,
       customBodyRender: (value, tableMeta, updateValue) => {
       return (<Typography>{formatMoney(value,0)}</Typography>);
     }
      }
     },{
      name: "tx_date",
      label: "Date",
      options: {
       filter: true,
       sort: true,
      }
     },
     {
      name: "tx_time",
      label: "Time",
      options: {
       filter: true,
       sort: false,
      }
     },
     {
        name: "status",
        label: "Status",
        options: {
         filter: true,
         sort: false,
         customBodyRender: (value, tableMeta, updateValue) => {
          return (<Chip size="small" icon={<CheckCircleOutline color="priamry"/>} label={value} color="primary" variant="outlined" />);
       }
        }
       }
   ];
  
   
   const options = {textLabels: {
    body: {
      noMatch: "No transactions available"
    },
  },
     filterType: 'checkbox',
     download:true,
     responsive:"standard",
     selectableRows:false,
     rowsPerPage: 10,
     elevation:0,
   };
  

   // format money 

function formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? "-" : "";

    let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
    let j = (i.length > 3) ? i.length % 3 : 0;

    return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
  } catch (e) {
    console.log(e)
  }
};

////////////////////////// TOP UP /////////////////////////


// get accounts associated to the phone number 

const [step,setStep]=useState(0);

const [panNumber,setPanNumber]=useState({value:"",error:""});

const [loadAccounts,setLoadAccounts]=useState(false);
const [accounts,setAccounts]=useState([]);
const [phone,setPhone]=useState({value:"",error:""});
const get_accounts=(p)=>{

    if(p.length==12 || p.length==19){
      setAccounts([]);
        setWallet({});
        setLoadAccounts(true);
        let url="";
        if(balanceMethod==false){
          url=new FinanceService().GET_ACCOUNTS+p;
        }else{
          url=new FinanceService().GET_CARD_PROFILE+p;
        }

        axios.defaults.baseURL = new FinanceService().BASE_URL;
        const accountsInstance = axios.create(new FinanceService().setHeaders(agentData.token));
        accountsInstance.get(url)
        .then(res=>{
          // console.log("accounts",objs);
          var objs=[];

          if(balanceMethod==false){
            objs=res.data.data;
          }else{
            objs.push(res.data.data);
          }
          
          setAccounts(objs);
          setLoadAccounts(false);
        })
        .catch(err=>{
          setLoadAccounts(false);
          setAccounts([]);
        });
    
      }else{
        if(balanceMethod==false){
          setPhone({value:"",error:"Enter valid phone number"});
        }else{
          setPanNumber({value:"",error:"Enter valid PAN number"});
        }
      }
  






}


const [wallet,setWallet]=useState({});

const [messageDialog,setMessageDialog]=useState(false);

const [topupLoad,setTopupLoad]=useState(false);
const [amount,setAmount]=useState({value:0,error:""});
const [response,setResponse]=useState({});
const topup=()=>{
  if(amount.value<=0){
    setAmount({value:0,error:""});
  }else{
    setTopupLoad(true);
    axios.defaults.baseURL = new FinanceService().BASE_URL;
    const topupInstance = axios.create(new FinanceService().setHeaders(agentData.token));
    topupInstance.post(new FinanceService().TOPUP_CUSTOMER,{
      "channel_type": "WEB",
      "channel_code": "WEB",
      "agent_code": new UserInfo().AGENT_CODE,
      "wallet_id": wallet['wallet_id'],
      "ext_ref_no": getRandom(9),
      "amount": amount.value
    })
    .then(res=>{
      var obj=res.data.data;
      setResponse(obj);

      setMessageDialog(true);
      enqueueSnackbar("Account credited successfuly!", { 
        variant: 'success',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
      },
    });
    setAccounts([]);
    setStep(0);
    
    setTopupLoad(false);

    // get transactions 

    setDay(Format(new Date(), ["yyyy-MM-dd",]));
    get_transactions(agentData.token,Format(new Date(), ["yyyy-MM-dd",]));

    // get new balance and etc info

    get_profile(agentData.token);
    // update weeklly report
    weeklyReport(agentData.token);

    })
    .catch(err=>{
      setTopupLoad(false);
  if(err.response){
    console.log(err.response.data.message);
  }
    });
  }
}


/// show transactions 
const [totalTransactions,setTotalTransactions]=useState(0);

const [commissions,setCommissions]=useState(0);

const [transactions,setTransactions]=useState([]);
const [transactionLoad,setTransactionLoad]=useState(false);

const [channels,setChannels]=useState([]);
const [channelsValue,setChannelsValue]=useState([]);


const [day,setDay]=useState(Format(new Date(), ["yyyy-MM-dd",]));

const [endDay,setEndDay]=useState(Format(new Date(),["yyyy-MM-dd",]));

const get_transactions=(token)=>{
  setTransactionLoad(true);
  setTransactions([])
  setChannelsValue([]);
  setChannels([]);
  setCommissions(0);
  setTotalTransactions(0);
  axios.defaults.baseURL = new FinanceService().BASE_URL;
  const transactionsInstance = axios.create(new FinanceService().setHeaders(token));
  transactionsInstance.get(new FinanceService().GET_TRANSACTIONS+new UserInfo().AGENT_CODE+"?start_date="+day+"&end_date="+endDay)
  .then(res=>{
    var objs=res.data.data;
    if(objs.length>0){
      var totalTrans=0;
      var com=0;
      var c=[];
      objs.map((o)=>{
        totalTrans=totalTrans+parseInt(o['amount']);
        c.push(o['channel_type']);
        com=com+ parseInt(o['total_commission_amount']);
      });
      setTotalTransactions(totalTrans);
      setCommissions(com);
      var unique_channels=c.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);
      var unique_transactions=[];
      unique_channels.map((u)=>{
        var count=0;
        objs.map((o)=>{
          if(o['channel_type']==u){
            count++;
          }
        });
        unique_transactions.push(count);
      });
      setChannels(unique_channels);
      setChannelsValue(unique_transactions);

      setTransactions(objs);
    }
    
    setTransactionLoad(false);
  })
  .catch(err=>{
    setTransactionLoad(false);
  });
};



// generate random number 

function getRandom(length) {

  return Math.floor(Math.pow(10, length-1) + Math.random() * 9 * Math.pow(10, length-1));
  
  }


  const [open,setOpen]=useState("");


  /// get devices 



  // devices table 

const columnsDevice = [
  {
    name: "device_type",
    label: "Device Type",
    options: {
     filter: true,
     sort: true,
    }
   },
  {
   name: "serial_number",
   label: "Serial Number",
   options: {
    filter: true,
    sort: true,
   }
  },
   {
      name: "status",
      label: "Status",
      options: {
       filter: true,
       sort: false,
       customBodyRender: (value, tableMeta, updateValue) => {
        return (<Chip size="small" icon={<CheckCircleOutline color="priamry"/>} label={value} color="primary" variant="outlined" />);
     }
      }
     }
 ];

 
 const optionsDevice = {textLabels: {
  body: {
    noMatch: "No devices available"
  },
},
   filterType: 'checkbox',
   download:true,
   responsive:"standard",
   selectableRows:false,
   rowsPerPage: 10,
   elevation:0,
 };

  const [deviceLoad,setDeviceLoad]=useState(false);
  const [devices,setDevices]=useState([]);
  const get_devices=()=>{
    setDeviceLoad(true);
    axios.defaults.baseURL = new FinanceService().BASE_URL;
    const devicesInstance = axios.create(new FinanceService().setHeaders(agentData.token));
    devicesInstance.get(new FinanceService().GET_DEVICES+new UserInfo().AGENT_CODE)
    .then(res=>{
      var objs=res.data.data;
      setDevices(objs);
      setDeviceLoad(false);
    })
    .catch(err=>{
      setDeviceLoad(false);
    });
  }


  /// get outlets 



const columnsOutlet = [
  {
    name: "code",
    label: "Code",
    options: {
     filter: true,
     sort: true,
    }
   },
  {
   name: "name",
   label: "Name",
   options: {
    filter: true,
    sort: true,
   }
  },
   {
      name: "status",
      label: "Status",
      options: {
       filter: true,
       sort: false,
       customBodyRender: (value, tableMeta, updateValue) => {
         if(value=="DISABLED"){
          return (<Chip size="small" icon={<Block color="secondary"/>} label={value} color="secondary" variant="outlined" />);
         }else{
          return (<Chip size="small" icon={<CheckCircleOutline color="priamry"/>} label={value} color="primary" variant="outlined" />);
         }
        
     }
      }
     }
 ];

 
 const optionsOutlet = {textLabels: {
  body: {
    noMatch: "No outlets available"
  },
},
   filterType: 'checkbox',
   download:true,
   responsive:"standard",
   selectableRows:false,
   rowsPerPage: 10,
   elevation:0,
 };



  const [outletLoad,setOutletLoad]=useState(false);
  const get_outlets=()=>{
    setOutletLoad(true);
    axios.defaults.baseURL = new FinanceService().BASE_URL;
    const outletsInstance = axios.create(new FinanceService().setHeaders(agentData.token));
    outletsInstance.get(new FinanceService().GET_OUTLETS+new UserInfo().AGENT_CODE)
    .then(res=>{
      var objs=res.data.data;
      setOutlets(objs);
      setOutletLoad(false);
    })
    .catch(err=>{
      setOutletLoad(false);
    });
  }



  // change password 

  const [changeDialog,setChangeDialog]=useState(false);

  const [oldPassword,setOldPassword]=useState({value:"",error:""});
  const [newPassword,setNewPassword]=useState({value:"",error:""});
  const [changeLoad,setChangeLoad]=useState(false);

  const change_password=()=>{
if(oldPassword.value==""){
      setOldPassword({value:"",error:"Enter valid password"});
    }else if(newPassword.value==""){
      setNewPassword({value:"",error:"Enter valid password"});
    }else{
      setChangeLoad(true);
      axios.defaults.baseURL = new AdminService().BASE_URL;
      const changeInstance = axios.create(new AdminService().setHeaders(agentData.token));
      changeInstance.put(new AdminService().CHANGE_PASSWORD,{
        "new_password": newPassword.value,
        "old_password": oldPassword.value
      })
      .then(res=>{
        enqueueSnackbar("Password changed successful!", { 
          variant: 'success',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        },
      });
      setChangeDialog(false);
      setChangeLoad(false);
      })
      .catch(err=>{
        setChangeLoad(false);
        if(err.response){
          enqueueSnackbar(err.response.data.message, { 
            variant: 'error',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
          },
        });
        }
      });
    }
    
  }

  // open topup


  const [openStatus,setOpenStatus]=useState("topup");


  // balance dialog

  const [balanceDialog,setBalanceDialog]=useState(false);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };


  const [logoutOpen, setLogoutOpen] = useState(false);






// popover for date fetching

const [weekTx,setWeekTx]=useState([0, 0, 0, 0,0, 0,0]);
const [anchorEl2, setAnchorEl2] = React.useState(null);

const handleClick2 = (event) => {
  setAnchorEl2(event.currentTarget);
};

const handleClose2 = () => {
  setAnchorEl2(null);
};

const open2 = Boolean(anchorEl2);
const id = open2 ? 'simple-popover' : undefined;


// weekly report 

const weeklyReport=(token)=>{
  var curr = new Date; 
  var first = curr.getDate() - curr.getDay()+1;
  var firstday = new Date(curr.setDate(first));   
  var lastday = new Date(curr.setDate(curr.getDate()+6));


  const startDate=Format(firstday,["yyyy-MM-dd",]);
  const endDate=Format(lastday,["yyyy-MM-dd",]);

  axios.defaults.baseURL = new FinanceService().BASE_URL;
  const transactionsInstance = axios.create(new FinanceService().setHeaders(token));
  transactionsInstance.get(new FinanceService().GET_TRANSACTIONS+new UserInfo().AGENT_CODE+"?start_date="+startDate+"&end_date="+endDate)
  .then(res=>{

    var objs=res.data.data;
    console.log("weekly transactions");
    console.log(objs);

    var groupByDay = groupBy(objs, function(item) {
      return [item.source,item.tx_date];
  });

  console.log("grouped by date");
  console.log(groupByDay);

  // var 

  var groupedTx=[];


  var weekday = new Array(7);
  weekday[0] = "Sunday";
  weekday[1] = "Monday";
  weekday[2] = "Tuesday";
  weekday[3] = "Wednesday";
  weekday[4] = "Thursday";
  weekday[5] = "Friday";
  weekday[6] = "Saturday";

  // var n = weekday[d.getDay()];


  var days=["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
  var daysTx=[0,0,0,0,0,0,0];

 
    groupByDay.map((o)=>{

      if(o['']){
  
      }
  
      var txs=o;
  
      var tx_date=txs[0]['tx_date'];
  
      var nDay=new Date(txs[0]['tx_date']);

      // console.log("day");

      // console.log(nDay.getDay());

      var index=nDay.getDay();
  
      var total_amount=txs.reduce(function (sum, amount) {
          return sum + parseInt(amount.amount);
      }, 0);
  
      daysTx[index]=total_amount;

      var obj={"date":tx_date,total_amount:total_amount};
  
      groupedTx.push(obj);
  });


 console.log("daysTx");
 console.log(daysTx);

 var ls=daysTx[0];
 daysTx.shift();
 daysTx.push(ls);

 console.log("after shift");
 console.log(daysTx);
 

 setWeekTx(daysTx);


console.log("grouped transction");
console.log(groupedTx);


    // group by week days 



  })
  .catch(err=>{
    

  });


}


const weeklyTopup={
          
  series: [{
    data: weekTx 
  }],
  options: {
    chart: {
      type: 'bar',
      height: 380
    },
    plotOptions: {
      bar: {
        barHeight: '100%',
        distributed: true,
        horizontal: true,
        dataLabels: {
          position: 'bottom'
        },
      }
    },
    colors: [ '#13d8aa', '#A5978B', '#2b908f', '#f9a3a4', '#90ee7e',
      '#f48024', '#69d2e7'
    ],
    dataLabels: {
      enabled: true,
      textAnchor: 'start',
      style: {
        colors: ['#fff']
      },
      formatter: function (val, opt) {
        return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val
      },
      offsetX: 0,
      dropShadow: {
        enabled: true
      }
    },
    stroke: {
      width: 1,
      colors: ['#fff']
    },
    xaxis: {
      categories: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
    },
    yaxis: {
      labels: {
        show: false
      }
    },
    title: {
        text: 'Weekly transactions',
        align: 'center',
        floating: true
    },
    tooltip: {
      theme: 'dark',
      x: {
        show: false
      },
      y: {
        title: {
          formatter: function () {
            return ''
          }
        }
      }
    }
  },


};



// search agent 

const [agentLoad,setAgentLoad]=useState(false)
const [agentCode,setAgentCode]=useState({value:"",error:""})
const [agentPro,setAgentPro]=useState(null);
const get_agent=(code)=>{
  if(agentCode!=""){
    setAgentLoad(true)
    axios.defaults.baseURL = new FinanceService().BASE_URL;
    const transactionsInstance = axios.create(new FinanceService().setHeaders(agentData.token));
    transactionsInstance.get(new FinanceService().GET_AGENT_PROFILE+code)
    .then(res=>{
      setAgentPro(res.data.data);
      setAgentLoad(false)
    })
    .catch(err=>{
      setAgentLoad(false)
    });
  }

}

// float allocation
const [floatAmount,setFloatAmount]=useState({value:0,error:""});
const [referenceNumber,setReferenceNumber]=useState({value:"",error:""});
const [floatLoad,setFloatLoad]=useState(false);

const float_allocation=()=>{

  if(referenceNumber.value==""){
    setReferenceNumber({value:"",error:"Invalid reference"})
  }else if(agentCode.value==""){
    setAgentCode({value:"",error:"Invalid agent code"})
  }else if(floatAmount.value<=0){
    setFloatAmount({value:0,error:"Invalid float"})
  }else{
    setFloatLoad(true)
    
    const data = {
      channel_type : "WEB",
      agent_code : new UserInfo().AGENT_CODE,
      dest_agent_code: agentCode.value,
      reference_number: referenceNumber.value,
      amount: floatAmount.value };

    axios.defaults.baseURL = new FinanceService().BASE_URL;
    const transactionsInstance = axios.create(new FinanceService().setHeaders(agentData.token));
    transactionsInstance.post(new FinanceService().FLOAT_ALLOCATION,data)
    .then(res=>{
      setFloatLoad(false)
      setAgentPro(null)
      enqueueSnackbar("Float has been allocated successful!", { 
        variant: 'success',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
      },
    });
      setAgentPro(null)
      setFloatLoad(false)
    })
    .catch(err=>{
      setFloatLoad(false)
      if(err.response){
        enqueueSnackbar(err.response.data.message, { 
          variant: 'error',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        },
      });
      }
    });
  }
}



  

    return(
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
<div className={classes.root}>
      <CssBaseline />
      <Dialog
        open={logoutOpen}
        onClose={() => setLogoutOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Logout"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to logout of your account?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setLogoutOpen(false)} color="primary">
            Cancel
          </Button>
          <Button
            onClick={() => {
              localStorage.removeItem("nx_ind");
              history.replace("/");
            }}
            color="primary"
            autoFocus
          >
            Logout
          </Button>
        </DialogActions>
      </Dialog>
   
     <Box> <AppBar position="fixed" elevation={0} className={classes.appBar}>
        <Toolbar>
          <img src={CentrikaIcon} alt="icon" className={classes.icon} />
          <Box className={classes.title}>
            <Typography variant={matches ? "h5" : "h6"} noWrap>
            {"AGENT"}
            </Typography>
          </Box>

          <Box ml={matches && 2}>
            <IconButton color="inherit">
              {/* <Badge
                badgeContent={1}
                showZero={false}
                variant="standard"
                color="secondary"
              > */}
                <Mail />
              {/* </Badge> */}
            </IconButton>
          </Box>

          <Box ml={matches && 2}>
            <IconButton color="inherit">
              {/* <Badge
                badgeContent={1}
                showZero={false}
                variant="standard"
                color="secondary"
              > */}
                <Notifications />
              {/* </Badge> */}
            </IconButton>
          </Box>

          <div>
            <Button
              onClick={handleMenu}
              color="inherit"
              variant={matches && "outlined"}
              size="small"
              className={classes.btn}
            endIcon={<Avatar>{new UserInfo().SHORT}</Avatar>}
              startIcon={matches && <img src={SafariLogo} height={35} />}
            ></Button>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              open={menuOpen}
              onClose={handleClose}
            >

              <MenuItem
               onClick={() => {
                setLogoutOpen(true);
                handleClose();
              }}
              >
                Logout
              </MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
      </Box>
        <div className={classes.main} />
 
 <Paper className={classes.root}>
      <Tabs
        value={value}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        centered
      >
        <Tab icon={<Home color="primary"/>} label="Home" {...a11yProps(0)}  />
        <Tab icon={<TrendingUp color="primary"/>} label="Transactions" {...a11yProps(1)}  />
        <Tab icon={<ImportExport color="primary"/>} label="Top Up"  {...a11yProps(2)} /> 
        <Tab icon={<SettingsOutlined color="primary"/>} label="Settings"  {...a11yProps(3)} />
        {/* {agentType=="GLOBAL AGENT"&&<Tab icon={<ConfirmationNumber color="primary"/>} label="Sale Ticket"  {...a11yProps(4)} />} */}
        <Tab icon={<Money color="primary"/>} label="Float Allocation"  {...a11yProps(4)} />
      </Tabs>
    </Paper>
    {/* home  */}
    <TabPanel value={value} index={0}>
        
    <Grid container spacing={2}>
    <Grid item xs={12} sm={12} md={12} lg={12}>
              <Box display="flex"><Home fontSize="large" color="primary"/><Typography style={{flexGrow:1}} variant="h6">Home</Typography><Event color="primary" fontSize="large"/> <Typography variant="h6">{Format(new Date(),["yyyy-MM-dd",])}</Typography></Box>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <Paper elevation={0} className={classes.paper}>
            <Box width={1} display="flex" justifyContent="center">
              <Box flexGrow={1}>
                <Typography color="textSecondary">Total Transactions</Typography>
                <Box mt={1} mb="4px" flexGrow={1}>
                  <Typography variant="h6">{totalTransactions+" FRW"}</Typography>
                </Box>
                {/* <Chip
                  color="primary"
                  size="small"
                  label="+12%"
                  deleteIcon={<ArrowDropUp />}
                  onDelete={()=>{

                  }}
                /> */}
              </Box>
              <SwapHoriz color="primary" fontSize="large" />
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <Paper elevation={0} className={classes.paper}>
            <Box display="flex" width={1}>
              <Box flexGrow={1}>
                <Typography color="textSecondary">Account Balance</Typography>
                <Box mt={1} mb="4px">
                <Typography variant="h6">{ formatMoney(balance)+" "+currency}</Typography>
                </Box>
                {/* <Chip
                className={classes.btn}
                  color="primary"
                  size="small"
                  label={statusAccount=="ENABLED"?"Active":"Inactive"}
                  deleteIcon={<Done />}
                  onDelete={()=>{

                  }}
                /> */}
              </Box>
              <AccountBalanceWallet color="primary" fontSize="large" />
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <Paper elevation={0} className={classes.paper}>
            <Box display="flex" width={1}>
              <Box flexGrow={1}>
                <Typography color="textSecondary">
                 Opening Balance
                </Typography>
                <Box mt={1} mb="4px">
                <Typography variant="h6">{ formatMoney(openBalance)+" "+currency}</Typography>
                </Box>
                {/* <Chip
                className={classes.btn}
                  color="primary"
                  size="small"
                  label={statusAccount=="ENABLED"?"Active":"Inactive"}
                  deleteIcon={<Done/>}
                  onDelete={()=>{

                  }}
                /> */}
              </Box>
              <AccountBalance color="primary" fontSize="large" />
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <Paper elevation={0} className={classes.paper}>
            <Box display="flex" width={1}>
              <Box flexGrow={1}>
                <Typography color="textSecondary">Commissions</Typography>
                <Box mt={1} mb="4px">
                <Typography variant="h6">{commissions+" RWF"}</Typography>
                </Box>
                {/* <Chip
                className={classes.btn}
                  color="primary"
                  size="small"
                  label="View Outlets"
                  onClick={()=>{

                  }}
                /> */}
              </Box>
              <Money color="primary" fontSize="large" />
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} md={12} lg={12} sm={12}>
            <Box display="flex">
                <Typography variant="h6" style={{flexGrow:1}}>Transactions</Typography>
            </Box>
        </Grid>
        <Grid item xs={12} md={6} lg={6} sm={6}>
            <Paper elevation={0}>
     <Chart   options={weeklyTopup.options} series={weeklyTopup.series} type="bar" height={380} />
     </Paper>
     </Grid>
     <Grid item xs={12} md={6} lg={6} sm={6}>
         <Paper elevation={0}>
         <Chart   options={AnnualTopUp.options} series={AnnualTopUp.series} type="bar" height={380} />
         </Paper>
     </Grid>

       </Grid>
        
      </TabPanel>

      {/* transactions  */}

      <TabPanel value={value} index={1}>
        <Grid container spacing={1}>
        
            <Grid item xs={12} sm={4} md={4} lg={4}>
                <Box>
                    <Box display="flex">
                        <Grid container spacing={1}>

                        <Grid item xs={2} sm={2} md={2} lg={2}>
                       
                         <Box display="flex" mt={2}> 
                         <Assessment color="primary" style={{height:30,width:30}}/>
                         <Typography variant="h5" color="secondary">Reports</Typography>
                        
                     
                         </Box>
                        </Grid>

                        <Grid item xs={8} sm={8} md={8} lg={8}>
                          <Box mt={3} display="flex" justifyContent="center">
                        <Chip
                  color="primary"
                  size="small"
                  variant="outlined"
                  label={day==endDay?day:day+" - "+endDay}
                  deleteIcon={<CalendarToday color={"#fff"}/>}
                  onDelete={()=>{

                  }}
                />
                </Box>
                        </Grid>




                        <Grid item xs={2} sm={2} md={2} lg={2}>
                        
                        <Box mt={1} >

                          
                        <IconButton aria-label="Calendar" aria-describedby={id} onClick={handleClick2}>
                          <DateRange fontSize="large" color="primary" />
                        </IconButton>

                        <Popover
                            id={id}
                            open={open2}
                            anchorEl={anchorEl2}
                            onClose={handleClose2}
                            anchorOrigin={{
                              vertical: 'bottom',
                              horizontal: 'center',
                            }}
                            transformOrigin={{
                              vertical: 'top',
                              horizontal: 'center',
                            }}
                          >
                            <Box p={2}>
                            <Box >
                            {/* <Typography >Please select dates</Typography> */}
                            </Box>
                            <Box>
                            <DatePicker
                fullWidth
                size="small"
                variant="inline"
                format="yyyy-MM-dd"
                margin="dense"
                autoOk
                label="Start Date"
                value={day}
                inputVariant="outlined"
                onChange={(v)=>{
                    setDay(Format(v, ["yyyy-MM-dd",]));
                  get_transactions(agentData.token,Format(v, ["yyyy-MM-dd",]));
                  handleClose2();
                }}
                InputProps={{
                  disableUnderline: true,
                  style: { paddingRight: 0 },
                }}
              />
               </Box>
                <Box>
                <DatePicker
                fullWidth
                size="small"
                variant="inline"
                format="yyyy-MM-dd"
                margin="dense"
                autoOk
                label="End Date"
                value={endDay}
                inputVariant="outlined"
                onChange={(v)=>{
                  setEndDay(Format(v, ["yyyy-MM-dd",]));
                  get_transactions(agentData.token,Format(v, ["yyyy-MM-dd",]));
                  handleClose2();
                }}
                InputProps={{
                  disableUnderline: true,
                  style: { paddingRight: 0 },
                }}
              />
                </Box>
              
                            </Box>
                          </Popover>

              {/* <DatePicker
                fullWidth
                size="small"
                variant="inline"
                format="yyyy-MM-dd"
                margin="dense"
                autoOk
                label="Filter"
                value={day}
                inputVariant="outlined"
                onChange={(v)=>{
                    setDay(Format(v, ["yyyy-MM-dd",]));
                  get_transactions(agentData.token,Format(v, ["yyyy-MM-dd",]));
                }}
                InputProps={{
                  disableUnderline: true,
                  style: { paddingRight: 0 },
                }}
              /> */}
            </Box>
                        
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Paper elevation={0} className={classes.paper}>
            <Box width={1} display="flex" justifyContent="center">
              <Box flexGrow={1}>
                <Typography color="textSecondary">Balance</Typography>
                <Box mt={1} mb="4px" flexGrow={1}>
                  <Typography variant="h8">{formatMoney(balance)+" "+currency}</Typography>
                </Box>
                <Chip
                  color="primary"
                  size="small"
                  label={"0%"}
                  deleteIcon={<ArrowDropUp />}
                  onDelete={()=>{

                  }}
                />
              </Box>
              <AccountBalanceWallet color="primary" fontSize="large" />
            </Box>
          </Paper>
         
                                </Grid>

                            <Grid item xs={12} sm={6} md={6} lg={6}>
                            <Paper elevation={0} className={classes.paper}>
            <Box width={1} display="flex" justifyContent="center">
              <Box flexGrow={1}>
                <Typography color="textSecondary">Total Transactions</Typography>
                <Box mt={1} mb="4px" flexGrow={1}>
                  <Typography variant="h8">{formatMoney(totalTransactions)+" "+currency}</Typography>
                </Box>
                <Chip
                  color="primary"
                  size="small"
                  label="0%"
                  deleteIcon={<ArrowDropUp />}
                  onDelete={()=>{

                  }}
                />
              </Box>
              <SwapHoriz color="primary" fontSize="large" />
            </Box>
          </Paper>
                            </Grid>

                            <Grid item xs={12} sm={6} md={6} lg={6}>
                            <Paper elevation={0} className={classes.paper}>
            <Box width={1} display="flex" justifyContent="center">
              <Box flexGrow={1}>
                <Typography color="textSecondary">Commissions</Typography>
                <Box mt={1} mb="4px" flexGrow={1}>
                  <Typography variant="h8">{formatMoney(commissions)+" "+currency}</Typography>
                </Box>
                <Chip
                  color="primary"
                  size="small"
                  label="0%"
                  deleteIcon={<ArrowDropUp />}
                  onDelete={()=>{

                  }}
                />
              </Box>
              <Money color="primary" fontSize="large" />
            </Box>
          </Paper>
                            </Grid>

                            

{/* channel types  */}

                                <Grid item xs={12} md={12} sm={12} lg={12}>
                                <Paper elevation={0} className={classes.paper}>
                                   
                                   <Box display="flex"><Typography style={{flexGrow:1}} variant="h6">Channels</Typography><Typography color="primary">All</Typography></Box>
                                   <List component="nav" aria-label="main mailbox folders">
                                     {channels.map((v,i)=>{
                                       return(
                                        <ListItem button>
                                        <ListItemIcon>
                                            
                                              <SettingsCell />
                                           
                                          
                                        </ListItemIcon>
                                        <ListItemText primary={v} />
                                        <ListItemSecondaryAction>
                                        <Badge
                                              badgeContent={channelsValue[i]}
                                              showZero={false}
                                              variant="standard"
                                              color="primary"
                                            />
                  </ListItemSecondaryAction>
                                      </ListItem>
                                       );
                                     })}
       
      </List>
                                    </Paper>

                                </Grid>
                        </Grid>
            
          
                    </Box>
                 </Box>
            </Grid>

            <Grid item xs={12} sm={8} md={8} lg={8}>
            <Box >
  {transactionLoad&&<LinearProgress/>}
<MUIDataTable
  title={<Typography variant="h6">Agent Transactions</Typography>}
  data={transactions}
  columns={columns}
  options={options}
/>
</Box> 
            </Grid>
        </Grid>
      </TabPanel>
      <TabPanel value={value} index={2}>
       <Grid container>
           <Grid xs={12} md={6} sm={6} lg={6}>
               <Box>
                   <Paper className={classes.paper}>
                     <Box display="flex" justifyContent="center">
                     <ButtonGroup color="primary" disableElevation >
                        <Button variant={openStatus=="topup"?"contained":"outlined"} onClick={()=>{
                          setAccounts([]);
                          setPanNumber({value:"",error:""});
                          setOpenStatus("topup");
                        }}>TopUp</Button>
                        <Button variant={openStatus=="balance"?"contained":"outlined"} onClick={()=>{
                          setAccounts([]);
                          setPanNumber({value:"",error:""});
                         setOpenStatus("balance") 
                        }}>Balance</Button>
                      </ButtonGroup>
                     </Box>
{openStatus=="topup"?
<Box>
                       <Box display="flex" ><Typography style={{flexGrow:1}} variant="h6">New Topup</Typography>

                       {step==0&&<Typography component="div">
                        <Grid component="label" container alignItems="center" spacing={1}>
                          <Grid item>Phone</Grid>
                          <Grid item>
                            <AntSwitch checked={balanceMethod} onChange={(e)=>{ setBalanceMethod(e.target.checked); }} name="balanceMethod" />
                          </Grid>
                          <Grid item>PAN</Grid>
                        </Grid>
                      </Typography>}


                       {step>0&&<IconButton onClick={()=>{
                         setStep(0);
                         setAccounts([]);
                       }}>
                         <CancelPresentationOutlined style={{color:"red"}} />
                       </IconButton>}

                       </Box>
                       {step==0&&
                       
                       <Box>
                         
                         
                         {balanceMethod==false?
                       <Box  mt={1}>
                          <Box display="flex">

                            
                            <TextField
                          
                           helperText={phone.error}
                           error={phone.error!=""}
                           onChange={(e)=>{
                             if(e.target.value==""){
                               setPhone({value:"",error:"Enter valid phone number"});
                             }else{
                               if(e.target.value.length!=10){
                                setPhone({value:"",error:"Enter valid phone number"});
                               }else if(e.target.value.length==10){
                                setPhone({value:"25"+e.target.value,error:""});
                               }else{
                                setPhone({value:"",error:"Enter valid phone number"});
                               }
                               
                             }
                           }}
                           placeholder="07********"
                            size="small" label="Phone Number" variant="outlined" type="text" fullWidth/>
                            <IconButton color="primary" size="small" aria-label="search account" component="span" onClick={()=>{
                               get_accounts(phone.value);
                            }}>
                              <FindReplace style={{height:35,width:35}} />
                            </IconButton>
                            </Box>

                            {loadAccounts&&<LinearProgress color="primary"/>}

                       </Box>:
                       <Box  mt={1}>
                         
                       <Box display="flex">
                         <TextField
                         style={{flexGrow:1}} 
                        helperText={panNumber.error}
                        error={panNumber.error!=""}
                        InputProps={{
                          startAdornment: (
                            <Typography>
                            5129-52
                            </Typography>
                          ),
                        }}
                        onChange={(e)=>{
                          if(e.target.value==""){
                            setPanNumber({value:"",error:"Enter valid PAN number"});
                          }else{
                            if(e.target.value.length!=12){
                             setPanNumber({value:"",error:"Enter valid PAN number"});
                            }else if(e.target.value.length==12){
                             setPanNumber({value:"5129-52"+e.target.value,error:""});
                            }else{
                             setPanNumber({value:"",error:"Enter valid PAN number"});
                            }
                            
                          }
                        }}
                        placeholder="**-****-****"
                         size="small" label="Phone Number" variant="outlined" type="text" fullWidth/>
                         <IconButton color="primary" size="small" aria-label="search account" component="span" onClick={()=>{
                           if(balanceMethod==false){

                            if(phone.value.length){
                              get_accounts(phone.value);
                            }

                           }else if(balanceMethod==true){

                            // get card info 
                           
                            if(panNumber.value.length==19){
                              console.log("get card info");
                              get_accounts(panNumber.value);
                            }

                           }else{

                           }
                            
                         }}>
                           <FindReplace style={{height:35,width:35}} />
                         </IconButton>
                         </Box>

                         {loadAccounts&&<LinearProgress color="primary"/>}

                    </Box>
                          }


                       <Box mt={1}>
                           Accounts
                           {accounts.length==0&&<Box>
                            <Box display="flex" justifyContent="center"><PaymentOutlined color="secondary" style={{height:100,width:100}} /></Box>
                             <Box display="flex" justifyContent="center">No bank account retrived</Box></Box>}

        <List component="nav" aria-label="main mailbox folders">
          {accounts.map((a)=>{
            
            if(a['wallet_type']=="CARD"){
              return(
                <ListItem button onClick={()=>{
                  setWallet(a);
                  setStep(1);
                }}>
                <ListItemIcon>
                      <AccountBalanceWalletOutlined fontSize="large" />
                </ListItemIcon>
                <ListItemText primary={a['account_name']} secondary={<Chip 
          className={classes.btn} 
          icon={ <AccountBalanceWallet/>} 
          size="small"
          color="primary" 
          variant="outlined" 
          label={a['status']} 
          />} />
              </ListItem>
              );
            }else{
              return(<Box></Box>);
            }
            
          })}
      </List>
                        </Box>
                        </Box>
}

{step==1&&<Box>
  <Box mt={1}>
  <List >

  <ListItem>
            <ListItemIcon>
            <AccountCircleOutlined color="secondary" fontSize="large" />
            </ListItemIcon>
            <ListItemText  primary={"Client"}  />
            <ListItemSecondaryAction>
            <Typography><b>{wallet['account_name']}</b></Typography>
            </ListItemSecondaryAction>
          </ListItem>

          <ListItem>
            <ListItemIcon>
            <PhoneAndroidOutlined color="secondary" fontSize="large" />
            </ListItemIcon>
            <ListItemText primary={"Phone number"}  />
            <ListItemSecondaryAction>
            <Typography><b>{wallet['phone_number']}</b></Typography>
            </ListItemSecondaryAction>
          </ListItem>
  
    <ListItem>
            <ListItemIcon>
            <AccountBalanceWalletOutlined color="secondary" fontSize="large" />
            </ListItemIcon>
            <ListItemText primary={"Current Balance"}  />
            <ListItemSecondaryAction>
            <Typography><b>{formatMoney(wallet['current_balance'])+" "+wallet['currency_code']}</b></Typography>
            </ListItemSecondaryAction>
          </ListItem>  

          

          <ListItem>
            <ListItemIcon>
            <AccountBalance color="secondary" fontSize="large" />
            </ListItemIcon>
            <ListItemText primary={"Account Number"}  />
            <ListItemSecondaryAction>
            <Typography><b>{wallet['account_number_formatted']}</b></Typography>
            </ListItemSecondaryAction>
          </ListItem>


          <ListItem>
            <ListItemIcon>
            <CreditCard color="secondary" fontSize="large" />
            </ListItemIcon>
            <ListItemText primary={"Wallet Type"}  />
            <ListItemSecondaryAction>
            <Typography><b>{wallet['wallet_type']}</b></Typography>
            </ListItemSecondaryAction>
          </ListItem>

          <ListItem>
            <ListItemIcon>
            <Today color="secondary" fontSize="large" />
            </ListItemIcon>
            <ListItemText primary={"Expiry Date"}  />
            <ListItemSecondaryAction>
            <Typography><b>{wallet['wallet_expiry_date']}</b></Typography>
            </ListItemSecondaryAction>
          </ListItem>
    </List>

  </Box>
                       <Box mt={1}>
                           <TextField onChange={(e)=>{
                             if(e.target.value<=0){
                               setAmount({value:0,error:"Enter valid amount"});
                             }else{
                               setAmount({value:e.target.value,error:""});
                             }
                           }} size="small" helperText={amount.error} error={amount.error!=""} label="Amount" variant="outlined" type="number" fullWidth/>
                       </Box>
                       <Box mt={1} display="flex" justifyContent="flex-end">
                          <Button onClick={()=>{
                            setStep(0);
                          }} color="secondary" variant="outlined">
                              Cancel
                          </Button>
                          <Button disabled={topupLoad} onClick={()=>{
                            topup();
                          }} style={{marginLeft:5}} elevation={0} color="primary" variant="contained">
                              {topupLoad?<CircularProgress size={25} color="secondary"/>:"TopUp"}
                          </Button>
                       </Box>
</Box>}
                       
</Box> 
:
<Box>
<Box display="flex" ><Typography style={{flexGrow:1}} variant="h6">Balance</Typography>
{step==0&&<Typography component="div">
                        <Grid component="label" container alignItems="center" spacing={1}>
                          <Grid item>Phone</Grid>
                          <Grid item>
                            <AntSwitch checked={balanceMethod} onChange={(e)=>{ setBalanceMethod(e.target.checked); }} name="balanceMethod" />
                          </Grid>
                          <Grid item>PAN</Grid>
                        </Grid>
                      </Typography>}
</Box>

<Box>
{balanceMethod==false?
                       <Box  mt={1}>
                          <Box display="flex">

                            
                            <TextField
                          
                           helperText={phone.error}
                           error={phone.error!=""}
                           onChange={(e)=>{
                             if(e.target.value==""){
                               setPhone({value:"",error:"Enter valid phone number"});
                             }else{
                               if(e.target.value.length!=10){
                                setPhone({value:"",error:"Enter valid phone number"});
                               }else if(e.target.value.length==10){
                                setPhone({value:"25"+e.target.value,error:""});
                               }else{
                                setPhone({value:"",error:"Enter valid phone number"});
                               }
                               
                             }
                           }}
                           placeholder="07********"
                            size="small" label="Phone Number" variant="outlined" type="text" fullWidth/>
                            <IconButton color="primary" size="small" aria-label="search account" component="span" onClick={()=>{
                               get_accounts(phone.value);
                            }}>
                              <FindReplace style={{height:35,width:35}} />
                            </IconButton>
                            </Box>

                            {loadAccounts&&<LinearProgress color="primary"/>}

                       </Box>:
                       <Box  mt={1}>
                         
                       <Box display="flex">
                         <TextField
                         style={{flexGrow:1}} 
                        helperText={panNumber.error}
                        error={panNumber.error!=""}
                        InputProps={{
                          startAdornment: (
                            <Typography>
                            5129-52
                            </Typography>
                          ),
                        }}
                        onChange={(e)=>{
                          if(e.target.value==""){
                            setPanNumber({value:"",error:"Enter valid PAN number"});
                          }else{
                            if(e.target.value.length!=12){
                             setPanNumber({value:"",error:"Enter valid PAN number"});
                            }else if(e.target.value.length==12){
                             setPanNumber({value:"5129-52"+e.target.value,error:""});
                            }else{
                             setPanNumber({value:"",error:"Enter valid PAN number"});
                            }
                            
                          }
                        }}
                        placeholder="**-****-****"
                         size="small" label="Phone Number" variant="outlined" type="text" fullWidth/>
                         <IconButton color="primary" size="small" aria-label="search account" component="span" onClick={()=>{
                           if(balanceMethod==false){

                            if(phone.value.length){
                              get_accounts(phone.value);
                            }

                           }else if(balanceMethod==true){

                            // get card info 
                           
                            if(panNumber.value.length==19){
                              console.log("get card info");
                              get_accounts(panNumber.value);
                            }

                           }else{

                           }
                            
                         }}>
                           <FindReplace style={{height:35,width:35}} />
                         </IconButton>
                         </Box>

                         {loadAccounts&&<LinearProgress color="primary"/>}

                    </Box>
                          }<Box mt={1}>
                           Accounts
                           {accounts.length==0&&<Box>
                            <Box display="flex" justifyContent="center"><PaymentOutlined color="secondary" style={{height:100,width:100}} /></Box>
                             <Box display="flex" justifyContent="center">No account retrived</Box></Box>}

        <List component="nav" aria-label="main mailbox folders">
          {accounts.map((a)=>{

if(a['wallet_type']=="CARD"){

            return(
              <ListItem button onClick={()=>{
                setWallet(a);
                setBalanceDialog(true);
              }}>
              <ListItemIcon>
                    <AccountBalanceWalletOutlined fontSize="large" />
              </ListItemIcon>
              <ListItemText primary={a['account_name']} secondary={<Chip 
        className={classes.btn} 
        icon={ <AccountBalanceWallet/>} 
        size="small"
        color="primary" 
        variant="outlined" 
        label={a['status']} 
        />} />
            </ListItem>
            );
              }else{
                return(<Box></Box>);
              }
          })}
      </List>
                        </Box>
                        </Box>


</Box>
}




                   
                   
                   </Paper>
               </Box>
           </Grid>
           <Grid xs={0} md={6} sm={6} lg={6}>
               <Box display="flex" justifyContent="center">
               {matches&&<img src={CardTopup} height="400" />}
               </Box>
              
           </Grid>
       </Grid>
      </TabPanel>


{/* settings  */}

      <TabPanel value={value} index={3}>
        <Grid container>
            <Grid item xs={12} md={6} sm={6} lg={6}>
                
  <Box mt={1} mr={1}>
   
   <Paper elevation={0}>
  
   <List
       component="nav"
       aria-labelledby="nested-list-subheader"
       className={classes.list}
     >
       
 
         <Box mt={1}>
         <Paper elevation={0}>
         <ListItem className={classes.list}  button onClick={()=>{
           setOpen("profile");
 }}> 
   <ListItemIcon>
     <AccountCircleOutlined fontSize="large"/>
   </ListItemIcon>
   <ListItemText primary="Profile" />
   <ArrowForwardIos />
 </ListItem>
             </Paper>
 
         </Box>
      
         <Box mt={1}>
         <Paper elevation={0}>
         <ListItem className={classes.list}  button onClick={()=>{
           get_devices();
setOpen("devices");
 }}> 
   <ListItemIcon>
     <Devices fontSize="large"/>
   </ListItemIcon>
   <ListItemText primary="Devices" />
   <ArrowForwardIos />
 </ListItem>
             </Paper>
 
         </Box>




         <Box mt={1}>
         <Paper elevation={0}>
         <ListItem className={classes.list}  button onClick={()=>{
setOpen("outlets");
 }}> 
   <ListItemIcon>
     <HdrWeak fontSize="large"/>
   </ListItemIcon>
   <ListItemText primary="Outlets" />
   <ArrowForwardIos />
 </ListItem>
             </Paper>
 
         </Box>

       
         <Box mt={1}>
         <Paper elevation={0}>
         <ListItem className={classes.list}  button onClick={()=>{
       
         }}>
   <ListItemIcon>
     <Language fontSize="large"/>
   </ListItemIcon>
   <ListItemText primary="Language" />
   <ArrowForwardIos />
 </ListItem>
             </Paper>
 
         </Box>
 
         <Box mt={1}>
         <Paper elevation={0}>
         <ListItem className={classes.list}  button onClick={()=>{
 
 }}>
   <ListItemIcon>
     <ImportantDevices fontSize="large"/>
   </ListItemIcon>
   <ListItemText primary="Appearance" />
   <ArrowForwardIos />
 </ListItem>
             </Paper>
 
         </Box>
         
     </List>
   </Paper>
   
   </Box>
 
            </Grid>
            <Grid item xs={12} md={6} sm={6} lg={6}>
              {open==""&&matches&&<Box>
               <Box display="flex" justifyContent="center"> <img src={Asettings} height="350" /></Box>
               <Box display="flex" justifyContent="center" >Select Specific setting</Box>
               </Box>}

               {open=="profile"&&<Box mt={1}>
                 <Paper elevation={0}>
               <Box  display="flex" justifyContent="center"><AccountCircleOutlined style={{height:80,width:80}} color="secondary" /></Box>
<Box display="flex" justifyContent="center"><Typography>{new UserInfo().AGENT_NAME}</Typography></Box>
               <Box p={5}>
               
               <List className={classes.root}>
    
          <ListItem  dense>
            <ListItemIcon>
              <PhoneAndroid color="secondary" fontSize="large"/>
            </ListItemIcon>
            <ListItemText primary={"Phone Number"} />
            <ListItemSecondaryAction>
<Typography>{new UserInfo().PHONE_NUMBER}</Typography>
            </ListItemSecondaryAction>
          </ListItem>
          
          <ListItem  dense>
            <ListItemIcon>
              <AlternateEmail color="secondary" fontSize="large"/>
            </ListItemIcon>
            <ListItemText primary={"Email"} />
            <ListItemSecondaryAction>
            <Typography>{new UserInfo().EMAIL}</Typography>
            </ListItemSecondaryAction>
          </ListItem>


          <ListItem  dense>
            <ListItemIcon>
              <AlternateEmail color="secondary" fontSize="large"/>
            </ListItemIcon>
            <ListItemText primary={"TIN"} />
            <ListItemSecondaryAction>
            <Typography>{agentProfile['tin_number']}</Typography>
            </ListItemSecondaryAction>
          </ListItem>


          <ListItem  dense>
            <ListItemIcon>
              <Public color="secondary" fontSize="large"/>
            </ListItemIcon>
            <ListItemText primary={"Address"} />
            <ListItemSecondaryAction>
            <Typography>{agentProfile['full_address']}</Typography>
            </ListItemSecondaryAction>
          </ListItem>

          <ListItem  dense>
            <ListItemIcon>
              <InsertDriveFileOutlined color="secondary" fontSize="large"/>
            </ListItemIcon>
            <ListItemText primary={"Contract Number"} />
            <ListItemSecondaryAction>
            <Typography>{agentProfile['contract_number']}</Typography>
            </ListItemSecondaryAction>
          </ListItem>


          <ListItem  dense>
            <ListItemIcon>
              <EventAvailable color="secondary" fontSize="large"/>
            </ListItemIcon>
            <ListItemText primary={"Contract start date"} />
            <ListItemSecondaryAction>
            <Typography>{agentProfile['contract_start_date']}</Typography>
            </ListItemSecondaryAction>
          </ListItem>


          <ListItem  dense>
            <ListItemIcon>
              <EventBusy color="secondary" fontSize="large"/>
            </ListItemIcon>
            <ListItemText primary={"Contract end date"} />
            <ListItemSecondaryAction>
            <Typography>{agentProfile['contract_end_date']}</Typography>
            </ListItemSecondaryAction>
          </ListItem>




          



          <ListItem  dense>
            <ListItemIcon>
              <VpnKey color="secondary" fontSize="large"/>
            </ListItemIcon>
            <ListItemText primary={"*********"} />
            <ListItemSecondaryAction>
              <IconButton edge="end" aria-label="comments" onClick={()=>{
                setChangeDialog(true);
              }}>
                <Edit />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>

     
    </List>
    </Box>
               </Paper>
                 </Box>}

{open=="devices"&&
  <Paper elevation={0}>
    <Box mt={1} display="flex">
      <Box m={2} style={{flexGrow:1}}><Typography >Devices</Typography></Box>
      <IconButton onClick={()=>{
        setOpen("");
      }}>
        <HighlightOff style={{color:"red"}} fontSize="large" />
      </IconButton>
    </Box>
    <Box>
      {deviceLoad&&<LinearProgress color="primary"/>}
    <MUIDataTable
    data={devices}
    columns={columnsDevice}
    options={optionsDevice}
    />
    </Box>
  </Paper>
}


{open=="outlets"&&
  <Paper elevation={0}>
    <Box mt={1} display="flex">
      <Box m={2} style={{flexGrow:1}}><Typography >Outlets</Typography></Box>
      <IconButton onClick={()=>{
        get_outlets();
        setOpen("");
      }}>
        <HighlightOff style={{color:"red"}} fontSize="large" />
      </IconButton>
    </Box>
    <Box>
      {outletLoad&&<LinearProgress color="primary"/>}
    <MUIDataTable
    data={outlets}
    columns={columnsOutlet}
    options={optionsOutlet}
    />
    </Box>
  </Paper>
}

            </Grid>
                    </Grid>
      </TabPanel>



{/* start float allocation  */}

<TabPanel value={value} index={4}>
       <Grid container>
           <Grid xs={12} md={6} sm={6} lg={6}>
               <Box>
                   <Paper className={classes.paper}>

                     <Box>
                       <Box display="flex" ><Typography style={{flexGrow:1}} variant="h6">Float Allocation</Typography>

                    


                       {step>0&&<IconButton onClick={()=>{
                         setStep(0);
                         setAccounts([]);
                       }}>
                         <CancelPresentationOutlined style={{color:"red"}} />
                       </IconButton>}

                       </Box>
                       {step==0&&
                       
                       <Box>
                         
                         <Box  mt={1}>
                          <Box display="flex">

                            
                            <TextField
                          
                           helperText={agentCode.error}
                           error={agentCode.error!==""}
                           onChange={(e)=>{
                            if(e.target.value!==""){
                              setAgentCode({value:e.target.value,error:""})
                            }
                           }}
                           placeholder="Agent Code"
                            size="small" label="Agent Code" variant="outlined" type="text" fullWidth/>
                            <IconButton color="primary" size="small" aria-label="search agent" component="span" onClick={()=>{
                              get_agent(agentCode.value);
                            }}>
                              <FindReplace style={{height:35,width:35}} />
                            </IconButton>
                            </Box>

                            {loadAccounts&&<LinearProgress color="primary"/>}

                       </Box>

                       {agentPro!=null&&
                       <Box mt={1}>
                       Agent Profile
                       <List className={classes.root}>
                       


                       <ListItem  dense>
      <ListItemIcon>
        <AccountCircle color="secondary" fontSize="large"/>
      </ListItemIcon>
      <ListItemText primary={"Name"} />
      <ListItemSecondaryAction>
<Typography>{agentPro.name}</Typography>
      </ListItemSecondaryAction>
    </ListItem>


    <ListItem  dense>
      <ListItemIcon>
        <PhoneAndroid color="secondary" fontSize="large"/>
      </ListItemIcon>
      <ListItemText primary={"Agent Code"} />
      <ListItemSecondaryAction>
<Typography>{agentPro.code}</Typography>
      </ListItemSecondaryAction>
    </ListItem>
    
    <ListItem  dense>
      <ListItemIcon>
        <AlternateEmail color="secondary" fontSize="large"/>
      </ListItemIcon>
      <ListItemText primary={"Email"} />
      <ListItemSecondaryAction>
      <Typography>{agentPro.email}</Typography>
      </ListItemSecondaryAction>
    </ListItem>







    <ListItem  dense>
      {/* <ListItemIcon>
        <VpnKey color="secondary" fontSize="large"/>
      </ListItemIcon> */}
      <ListItemText primary={<TextField
                          type="text"
                          helperText={referenceNumber.error}
                          error={referenceNumber.error!==""}
                          onChange={(e)=>{
                           if(e.target.value!==""){
                            setReferenceNumber({value:e.target.value,error:""})
                           }else{
                            setReferenceNumber({value:"",error:"Invalid reference"})
                           }
                          }}
                          placeholder="Reference Number"
                           size="small" label="Reference Number" variant="outlined" fullWidth/>} />
    </ListItem> 



    <ListItem  dense>
      {/* <ListItemIcon>
        <VpnKey color="secondary" fontSize="large"/>
      </ListItemIcon> */}
      <ListItemText primary={<TextField
                          type="number"
                          helperText={floatAmount.error}
                          error={floatAmount.error!==""}
                          onChange={(e)=>{
                           if(e.target.value!==0){
                            setFloatAmount({value:e.target.value,error:""})
                           }else{
                            setFloatAmount({value:"",error:"Invalid float amount"})
                           }
                          }}
                          placeholder="Float Amount"
                           size="small" label="Float Amount" variant="outlined" fullWidth/>} />
  
    </ListItem>

    <ListItem  dense>
      <ListItemText primary={<Button disabled={floatLoad} onClick={()=>{
                            float_allocation();
                          }} style={{marginLeft:5}} disableElevation={true}  color="primary" variant="contained">
                              {floatLoad?<CircularProgress size={25} color="secondary"/>:"Allocate"}
                          </Button>}/>
    </ListItem>


</List>

                    </Box>
                       }

                        </Box>
}

{step==1&&<Box>
  <Box mt={1}>
  <List >

  <ListItem>
            <ListItemIcon>
            <AccountCircleOutlined color="secondary" fontSize="large" />
            </ListItemIcon>
            <ListItemText  primary={"Client"}  />
            <ListItemSecondaryAction>
            <Typography><b>{wallet['account_name']}</b></Typography>
            </ListItemSecondaryAction>
          </ListItem>

          <ListItem>
            <ListItemIcon>
            <PhoneAndroidOutlined color="secondary" fontSize="large" />
            </ListItemIcon>
            <ListItemText primary={"Phone number"}  />
            <ListItemSecondaryAction>
            <Typography><b>{wallet['phone_number']}</b></Typography>
            </ListItemSecondaryAction>
          </ListItem>
  
    <ListItem>
            <ListItemIcon>
            <AccountBalanceWalletOutlined color="secondary" fontSize="large" />
            </ListItemIcon>
            <ListItemText primary={"Current Balance"}  />
            <ListItemSecondaryAction>
            <Typography><b>{formatMoney(wallet['current_balance'])+" "+wallet['currency_code']}</b></Typography>
            </ListItemSecondaryAction>
          </ListItem>  

          

          <ListItem>
            <ListItemIcon>
            <AccountBalance color="secondary" fontSize="large" />
            </ListItemIcon>
            <ListItemText primary={"Account Number"}  />
            <ListItemSecondaryAction>
            <Typography><b>{wallet['account_number_formatted']}</b></Typography>
            </ListItemSecondaryAction>
          </ListItem>


          <ListItem>
            <ListItemIcon>
            <CreditCard color="secondary" fontSize="large" />
            </ListItemIcon>
            <ListItemText primary={"Wallet Type"}  />
            <ListItemSecondaryAction>
            <Typography><b>{wallet['wallet_type']}</b></Typography>
            </ListItemSecondaryAction>
          </ListItem>

          <ListItem>
            <ListItemIcon>
            <Today color="secondary" fontSize="large" />
            </ListItemIcon>
            <ListItemText primary={"Expiry Date"}  />
            <ListItemSecondaryAction>
            <Typography><b>{wallet['wallet_expiry_date']}</b></Typography>
            </ListItemSecondaryAction>
          </ListItem>
    </List>

  </Box>
                       <Box mt={1}>
                           <TextField onChange={(e)=>{
                             if(e.target.value<=0){
                               setAmount({value:0,error:"Enter valid amount"});
                             }else{
                               setAmount({value:e.target.value,error:""});
                             }
                           }} size="small" helperText={amount.error} error={amount.error!=""} label="Amount" variant="outlined" type="number" fullWidth/>
                       </Box>
                       <Box mt={1} display="flex" justifyContent="flex-end">
                          <Button onClick={()=>{
                            setStep(0);
                          }} color="secondary" variant="outlined">
                              Cancel
                          </Button>
                          <Button disabled={topupLoad} onClick={()=>{
                            topup();
                          }} style={{marginLeft:5}} elevation={0} color="primary" variant="contained">
                              {topupLoad?<CircularProgress size={25} color="secondary"/>:"TopUp"}
                          </Button>
                       </Box>
</Box>}
                       
                     </Box> 





                   
                   
                   </Paper>
               </Box>
           </Grid>
           <Grid xs={0} md={6} sm={6} lg={6}>
               <Box display="flex" justifyContent="center">
               {matches&&<img src={FloatAllocation} height="400" />}
               </Box>
              
           </Grid>
       </Grid>
      </TabPanel>


{/* end float allocation  */}



{/* topup message  */}





<Dialog
    maxWidth="sm"
    fullWidth
        open={messageDialog}
        onClose={()=>{
          setWallet({});
          setMessageDialog(false);
        }}
        aria-labelledby="message"
        aria-describedby="message"
      >
        <DialogTitle id="message">{"Message"}</DialogTitle>
        <DialogContent>
          <DialogContentText >
          <Box>
              
         <Box mt={1} display="flex" justifyContent="center">
           <CheckCircleOutlined color="primary" style={{height:80,width:80}} />
         </Box>
          <Box mt={1} display="flex" justifyContent="center">
      <Typography color="">Customer account has been credited <b>{formatMoney(amount.value)+" "+wallet['currency_code']}</b> successfuly!<br/> New balance is <b>{formatMoney(response['credited_account_balance'])+" "+wallet['currency_code']}</b>  </Typography>            
          </Box>

          </Box>
         </DialogContentText>
         </DialogContent>

         <DialogActions>
         
          <Button onClick={()=>{
            setMessageDialog(false);
            setWallet({});
          }} color="secondary" className={classes.btn}>
            <Typography>Close</Typography>
          </Button>

        </DialogActions>
         </Dialog>



{/* change password  */}



<Dialog
    maxWidth="sm"
    fullWidth
        open={changeDialog}
        onClose={()=>{

         setChangeDialog(false);

        }}
        aria-labelledby="change_password"
        aria-describedby="change_password"
      >
        <DialogTitle id="change_password">{"Change Password"}</DialogTitle>
        <DialogContent>
          <DialogContentText >
          <Box>
          <Box display='flex' alignItems='center' justifyContent='center'>
               <TextField size='small' type="password" variant='outlined' label={"Old Password"} fullWidth
               onChange={(e)=>{
                 if(e.target.value===""){
                   setOldPassword({value:"",error:"Enter valid password"})
                 }else{
                   setOldPassword({value:e.target.value,error:""});
                 }
               }} 
               error={oldPassword.error!==""}
               helperText={oldPassword.error}/>
              </Box>


              <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
               <TextField size='small' type="password" variant='outlined' label={"New Password"} fullWidth
               onChange={(e)=>{
                 if(e.target.value===""){
                   setNewPassword({value:"",error:"Enter valid New password"})
                 }else{
                   setNewPassword({value:e.target.value,error:""});
                 }
               }} 
               error={newPassword.error!==""}
               helperText={newPassword.error}/>
              </Box>

        </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          
          <Button onClick={()=>{
            
         setChangeDialog(false);

          }} color="secondary" variant="outlined" >
            close
          </Button>

          <Button color="primary" onClick={()=>{
            
            change_password();

             }}  variant="contained" >
              {changeLoad?<CircularProgress size={25} color="secondary"/>:"Save"} 
             </Button>
         
        </DialogActions>
      </Dialog>

{/* dialog balance  */}



<Dialog
    maxWidth="sm"
    fullWidth
        open={balanceDialog}
        onClose={()=>{
          setBalanceDialog(false);
        }}
        aria-labelledby="balance"
        aria-describedby="balance"
      >

        <DialogTitle id="balance">{"Balance"}</DialogTitle>
        <DialogContent>
          <DialogContentText >
          <Box>
          <List component="nav">
        <ListItem >
          <ListItemIcon>
            <img src={cBalance} width="30px" height="30px" />
          </ListItemIcon>
          <ListItemText primary="Current balance" secondary={<b>{formatMoney(wallet['current_balance'])+" "+wallet['currency_code']}</b>} />
        </ListItem>
        <ListItem >
          <ListItemIcon>
          <img src={oBalance} width="30px" height="30px" />
          </ListItemIcon>
      <ListItemText primary="Openning balance" secondary={<b>{formatMoney(wallet['opening_balance'])+" "+wallet['currency_code']}</b>} />
        </ListItem>
        <ListItem >
          <ListItemIcon>
          <img src={reserved} width="30px" height="30px" />
          </ListItemIcon>
      <ListItemText primary="Reserved balance" secondary={<b>{formatMoney(wallet['reserved_amount'])+" "+wallet['currency_code']}</b>} />
        </ListItem>
      </List>        
        </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          
          <Button onClick={()=>{

            setAccounts([]);
            setBalanceDialog(false);

          }} color="secondary" variant="outlined" >
            close
          </Button>

         
        </DialogActions>
      </Dialog>
</div>
</MuiPickersUtilsProvider>
    );
}

export default withLocalize(HomeIndividual);